(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('[data-gallery]:not([data-ready])').forEach(gallery => {
      gallery.dataset.ready = 'true';
      gallery.addEventListener('click', event => {
        const button = event.target.closest('[data-slide-button]');
        const arrow = event.target.closest('[data-slide-step]');
        if (!button && !arrow) return;
        const slides = [...gallery.querySelectorAll('[data-slide]')];
        const active = slides.findIndex(slide => !slide.hidden);
        const index = button ? Number(button.dataset.slideButton) : (active + Number(arrow.dataset.slideStep) + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause()); });
        gallery.querySelectorAll('[data-slide-button]').forEach(item => item.setAttribute('aria-pressed', String(Number(item.dataset.slideButton) === index)));
      });
    });
    root.querySelectorAll('[data-variant-select]:not([data-ready])').forEach(select => {
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const section = select.closest('[data-product-section]');
        const price = section?.querySelector('[data-product-price]');
        const button = section?.querySelector('[name="add"]');
        if (price) price.textContent = option.dataset.price;
        if (button) { button.disabled = option.dataset.available !== 'true'; button.firstChild.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel; }
      });
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-quantity]');
    if (!button) return;
    const input = button.closest('.fs-quantity')?.querySelector('input');
    if (!input) return;
    const min = Number(input.min || 1);
    input.value = Math.max(min, (Number(input.value) || min) + Number(button.dataset.quantity));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-localization]')) event.target.form.requestSubmit();
  });
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.fs-mobile-nav[open]').forEach(menu => menu.removeAttribute('open'));
  });
  initialise();
})();
